import React, { useEffect } from 'react'
import { NavLink, useHistory } from 'react-router-dom'

import { useIsAuthenticated } from '../../../../hooks/use-is-authenticated'
import { signUp } from '../../../../lib/analytics/events'
import { getModalLocation } from '../../../../lib/modal'
import { MODALS, SIGN_UP_SCREENS } from '../../../../constants'
import CreateAccountForm from './create-account-form'
import styles from '../sign-up.css'

const CreateAccount = () => {
  const currentScreen = SIGN_UP_SCREENS.CREATE_ACCOUNT
  const history = useHistory()
  const isAuthenticated = useIsAuthenticated()

  useEffect(() => {
    if (isAuthenticated) {
      history.push('/')
    } else {
      signUp.start()
      signUp.stepViewed(currentScreen.datalayerStepSequence, currentScreen.datalayerStepLabel)
    }
  }, [isAuthenticated])

  const loginLink = getModalLocation(location, MODALS.qsParams.login)

  return (
    <>
      <div className={styles.header}>Create your account</div>
      <div className={styles.container}>
        <CreateAccountForm />
      </div>
      <div className={styles.link}>
        Already have an account?&nbsp;
        <NavLink to={loginLink}>
          Log in here
        </NavLink>
      </div>
    </>
  )
}

export default CreateAccount
